import { render, staticRenderFns } from "./ReceitaCard.vue?vue&type=template&id=15239db6"
import script from "./ReceitaCard.vue?vue&type=script&lang=js"
export * from "./ReceitaCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports